// The unticked "Send me The Weekly Close" box — which sign-ups offer it, and the
// wording. One place to edit: Dave reviews this wording later. To offer the box
// on another sign-up, add its slug.

export const NEWSLETTER_OPTIN_LABEL = 'Send me The Weekly Close: one short email each Thursday';
export const NEWSLETTER_OPTIN_DONE = "You're on The Weekly Close ✓";

/** Registration assessments (events) that offer the box. */
export const NEWSLETTER_OPTIN_EVENT_SLUGS: ReadonlySet<string> = new Set(['summit-2026-na', 'summit-2026-au']);
/** Calls whose RSVP and thank-you pages offer the box. */
export const NEWSLETTER_OPTIN_CALL_SLUGS: ReadonlySet<string> = new Set(['tsb-builds', 'tsb-live']);

export const offersNewsletterOnEvent = (slug: string | null | undefined): boolean =>
  !!slug && NEWSLETTER_OPTIN_EVENT_SLUGS.has(slug);
export const offersNewsletterOnCall = (slug: string | null | undefined): boolean =>
  !!slug && NEWSLETTER_OPTIN_CALL_SLUGS.has(slug);
